/*
 * A gate's width (Android GateWidth.kt): stored as a string of whole inches;
 * older rows may hold free text, which is shown as written.
 */

/** 50 ft: wider than any yard gate. */
export const GATE_MAX_INCHES = 600;
/** Under 5 ft widths read in plain inches ("36 in"); from there feet and inches ("10 ft 6 in"). */
const FEET_FROM_INCHES = 60;

export function formatGateWidth(inches: number): string {
  const feet = Math.floor(inches / 12);
  const rest = inches % 12;
  if (inches < FEET_FROM_INCHES) return `${inches} in`;
  return rest === 0 ? `${feet} ft` : `${feet} ft ${rest} in`;
}

/** Every inch from 1 in to 50 ft. */
export const GATE_WIDTH_OPTIONS: string[] = Array.from({length: GATE_MAX_INCHES}, (_, i) => formatGateWidth(i + 1));

/** The inches a stored width starts with, or undefined for none / free text. */
export function gateWidthInches(raw: string | undefined | null): number | undefined {
  const match = raw?.match(/^\s*(\d+(?:\.\d+)?)/);
  return match ? Math.round(parseFloat(match[1])) : undefined;
}

/** What the panel shows for a stored width: feet and inches, the text as written, or '' for none. */
export function gateWidthLabel(raw: string | undefined | null): string {
  if (!raw?.trim()) return '';
  const inches = gateWidthInches(raw);
  if (inches === undefined) return raw;
  return inches === 0 ? '' : formatGateWidth(inches);
}
